import React from "react";
import { Accordion } from "rsuite";
import TaxPayableBreakdownTable from "../../tax/BreakdownTable/TaxPayableBreakdownTable";
import ReportedLicensePeriodHeader from "./ReportedLicensePeriodHeader.";

const ReportedLicensePeriod = ({ licensePeriod, onLicenseSelected, isMobile, expanded }) => {
  return (
    <Accordion
      activeKey={isMobile ? '' : undefined}
      onSelect={(eventKey) => {
        onLicenseSelected(eventKey);
        return;
      }}
    >
      <Accordion.Panel
        className="reporting-history-accordion-header"
        eventKey={licensePeriod.uniqueKey}
        header={
          <ReportedLicensePeriodHeader licensePeriod={licensePeriod} />
        }
        expanded={expanded}
      >
        <TaxPayableBreakdownTable
          license={licensePeriod.providers}
          periodLabel={licensePeriod.label}
          processingFee={licensePeriod.processingFee}
          totalPayment={licensePeriod.paymentAmount} />
      </Accordion.Panel>
    </Accordion>
  );
};

export default ReportedLicensePeriod; 
